import { render, staticRenderFns } from "./VisitsStatistics.vue?vue&type=template&id=5157214f&"
import script from "./VisitsStatistics.vue?vue&type=script&lang=js&"
export * from "./VisitsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports